import { render, staticRenderFns } from "./sortDrop.vue?vue&type=template&id=2d260361&scoped=true&"
import script from "./sortDrop.vue?vue&type=script&lang=js&"
export * from "./sortDrop.vue?vue&type=script&lang=js&"
import style0 from "./sortDrop.vue?vue&type=style&index=0&id=2d260361&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d260361",
  null
  
)

export default component.exports